import axios from "../utils/axios";


// Upload Excel file
export const createCategoryApi = (formData) =>
  axios.post("/api/category", formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });


// Get all categories
export const getCategoriesApi = () =>
  axios.get("/api/category");

// Get single category by ID
export const getCategoryByIdApi = (id) =>
  axios.get(`/api/category/id`, { 
    params: { id } 
  });


export const updateCategoryApi = (id, formData) =>
  axios.put("/api/category/update", { id, ...formData }, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });

// Delete category
export const deleteCategoryApi = (id) =>
  axios.delete(`/api/category/delete/${id}`);

// Toggle category
export const toggleCategoryApi = (id) =>
  axios.put(`/api/category/toggle/${id}`);